/**
 * Système de logging conditionnel
 * Affiche les logs uniquement en développement
 */

const isDev = import.meta.env?.DEV ?? (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development');

export const logger = {
  debug: (...args: any[]) => {
    if (isDev) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDev) {
      console.info('[INFO]', ...args);
    }
  },
  
  warn: (...args: any[]) => {
    console.warn('[WARN]', ...args);
  },
  
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },
  
  // Logs spécifiques pour les widgets
  widget: (...args: any[]) => {
    if (isDev) {
      console.log('[WIDGET]', ...args);
    }
  },
  
  // Logs spécifiques pour les API calls
  api: (...args: any[]) => {
    if (isDev) {
      console.log('[API]', ...args);
    }
  },
  
  // Logs spécifiques pour les layouts
  layout: (...args: any[]) => {
    if (isDev) {
      console.log('[LAYOUT]', ...args);
    }
  }
};

export default logger;
